<template>
    <div id="app" class="site container hfeed" style="height: auto !important">
        <HeadNav selectedLanguage="en" page="download" />

        <div id="content" class="main-wrapper" style="height: auto !important;">
            <div class="markdown-content">
                <h1>How to Create a GBWhatsApp Theme?</h1>

                <img src="@/assets/blog-2.webp" alt="create a gbwhatsapp theme">

                <p>GBWhatsApp is an unofficial WhatsApp client that has more customization features compared to the
                    official WhatsApp client, particularly in designing the application user interface. Using
                    GBWhatsApp, a user has the ability to design the overall look of the application based on their
                    choice, including the message service interface, icon, font style, and overall application color.
                    This paper will discuss <strong>custom theme creation using <a
                            href="https://gbwaonline.com/">GBWhatsApp</a></strong> and its application in improving user
                    experience.</p>

                <h2>Choosing the Right GBWhatsApp Theme Editor</h2>

                <p>First of all, in the creation of GBWhatsApp themes, you need to choose a good tool to edit the
                    themes. GBWhatsApp provides a theme function, and thus users can directly design and modify their
                    themes in the app. Still, users can make more detailed customization by using some third-party
                    applications or files for the themes.</p>

                <ul>
                    <li><strong>Built-in theme editor:</strong> GBWhatsApp comes equipped with an inbuilt theme editor
                        through which the user can personalize various features such as the color scheme, font, or
                        application interface.</li>
                    <li><strong>Third-party tools:</strong> Third-party tools such as applications and theme libraries
                        may be able to allow the user to have some customization choices available to them.</li>
                </ul>

                <h2>Key Design Elements of GBWhatsApp Themes</h2>

                <p>When creating a GBWhatsApp theme, several design elements need to be taken into consideration, as
                    these elements will affect the overall effect of the theme.</p>

                <h3>Background Setup</h3>

                <p>The background pattern is one of the key elements in influencing the appearance of the GBWhatsApp
                    theme. Users may also choose a single-color background or employ their own photos or designed images
                    as the background. Appropriate background selection can bring a more personalized look to the
                    WhatsApp interface.</p>

                <h3>Font and Text Color</h3>

                <p>The font and color of the text are very important for readability and aesthetic factors of the theme.
                    GBWhatsApp allows users to change font style, size, and color. Select a font style to your liking
                    with your usage habits and match up with appropriate text color, the chat interface will make more
                    clear and easily readable.</p>

                <h3>Dialog Box Style</h3>

                <p>The dialog box style and color will have direct influence on the appearance of the chat interface.
                    The dialog box style can include different shapes, sizes of bubbles, and various colors. The display
                    style of messages exchanged between the user and other can also be modified by the user. An
                    appropriate dialog box style can harmonize and beautify the chat interface.</p>

                <h3>Icon and Button Design</h3>

                <p>The GBWhatsApp allows users to customize the icons and buttons of the application, including main
                    interface icons, chat interface buttons, as well as settings menu buttons, among others. The users
                    can select various designs of the icons depending on their preference to improve the visual
                    experience.</p>

                <h2>How to Create a Theme in GBWhatsApp</h2>

                <h3>
                    <ol start="1">
                        <li>
                            Enter the topic settings interface
                        </li>
                    </ol>
                </h3>


                <p>Open the GBWhatsApp application, access the "Settings" option, and look for the "Themes" option. In
                    the theme settings, the users have the ability to either customize the themes or download the
                    pre-existing templates of themes. Users have the freedom within the setting options to choose
                    personal aspects of the themes, including the background, font, and buttons.</p>

                <h3>
                    <ol start="2">
                        <li>Selecting the Theme Color</li>
                    </ol>
                </h3>

                <p>In the theme setting, picking the right theme color is an important task. GBWhatsApp allows you to
                    choose from various themes, along with the facility to change the color of your choice using the
                    color selector. It is advisable to choose colors of your choice that may match your personality,
                    along with a right combination of colors. Do not opt for bright colors.</p>

                <h3>
                    <ol start="3">
                        <li>Modify the background and interface elements</li>
                    </ol>
                </h3>


                <p>Depending on personal preference, the user can choose various background images or colors. Among the
                    background options, the user can choose whether to have a transparent background, gradient
                    background, and other effects. Apart from the background, the user can alter various options
                    including the appearance of the chat box, font styles, and button colors and shapes.</p>

                <h3>
                    <ol start="4">
                        <li>Preview and Save the Theme</li>
                    </ol>
                </h3>

                <p>Now that users are done with the setting of their theme, they are also able to preview the impact
                    that the theme could have on their GBWhatsApp by utilizing the "Preview" option that is available to
                    them. Should they want to make use of it, then they are able to save it in order to apply it on the
                    entire GBWhatsApp screen.</p>

                <h2>Managing and Updating GBWhatsApp Themes</h2>

                <p>Using GBWhatsApp, users can control and update the installed themes anytime. If the user wants to
                    change the themes or uninstall the ones they do not like, they can do this by using the interface
                    provided by the theme settings. Updating the themes allows the user to have freshness in the
                    WhatsApp interface and make changes as per the seasonal or festival requirements.</p>

                <h2>Downloading and Sharing GBWhatsApp Themes</h2>

                <h3>Download GBWhatsApp Themes</h3>

                <p>Other than customizing and importing, users also have the option to download themes for GBWhatsApp
                    straight from the internet. Various websites and forums provide a vast number of themes that users
                    can choose from for free. Users also have the freedom to choose and download their themes of
                    interest.</p>

                <h3>Share Custom Themes</h3>

                <p>If you create a unique and attractive theme, you can easily share it with your friends via
                    GBWhatsApp. After sharing the theme file, other users can import and use the same theme.</p>

                <h2>Conclusion</h2>

                <p>With so many features available for customization, GBWhatsApp themes create an important way to
                    enhance user experience. The possibility to change backgrounds, fonts, color, and icons will let you
                    make a unique interface to better suit your taste or preference. Be it customizing the themes,
                    downloading, or even sharing, GBWhatsApp has powerful theme management tools to assist users in
                    enjoying a more personalized experience with its usage.</p>
            </div>
            <RelatedArticles />

        </div>
    </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import DownloadBtn from '@/components/DownloadBtn.vue';
import RelatedArticles from '@/components/RelatedArticles.vue';

export default {
    name: 'blog-2',
    data() {
        return {
            pageName: 'blog-2',
            showapk: false,

            apk: null,
            from: 'gb',
            filename: 'gb',
            selectedLanguage: 'en',
        };
    },
    components: {
        HeadNav, DownloadBtn, RelatedArticles
    },
    mounted() {
        this.from = this.$global.GetQueryString('from') || this.from;
        this.filename = this.$global.GetQueryString('filename') || this.filename;
        console.log(this.$global.GetQueryString('from'));
        if (this.$global.GetQueryString('from')) {
            this.getAPK();
        } else {
            this.getOfficalApk();
        }
    },
    methods: {
        downloadfrom(reason) {
            // this.download();
            // this.$logEvent(`download_from_${reason}`, 'download');
            // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
        },
        gotoblog() {
            window.location.href = '/blogs';
        },
        getAPK() {
            this.$server
                .getAPPInfo({
                    promotionChannel: this.from,
                    promotionName: this.filename,
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.apk = res.data.apk;
                    } else {
                        this.apk = 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk';
                    }
                });
        },
        getOfficalApk(type = 1, domain = null, appname = null) {
            this.$server
                .getOfficalApk({
                    domain: domain || 'gbwhatsapp.chat',
                    appName: appname || 'GB_gbwhatsapp.chat',
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        if (type == 1) {
                            this.apk = res.data.apk;
                        }
                        this.lastupdate = res.data.promotion.updateTime;
                        this.votes = res.data.promotion.totalCount;
                        this.rating = res.data.promotion.score;
                        console.log('apk getted');
                    } else {
                        this.apk = 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk';
                    }
                });
        },
        download() {
            console.log(this.apk);
            // this.showapk = true
            if (this.apk) {
                this.$global.download(this.apk);
            }
        },
        goto(page) {
            this.$router.push({
                name: `${this.selectedLanguage}-${page}`
            });
        }
        // download() {
        // 	console.log(this.apk);
        // 	this.$global.download(this.apk);
        // },
    },
};
</script>

<style lang="scss" scoped>
.markdown-content {
    padding: 20px;
    line-height: 1.6;
    margin: 20px auto;
    max-width: 1000px;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.markdown-content h1 {
    font-size: 2em;
    margin: 0.67em 0;
    border-bottom: 2px solid #eee;
    padding-bottom: 0.3em;
    color: #2d3748;
    text-align: center;
}

.markdown-content h2 {
    font-size: 1.5em;
    margin: 0.75em 0;
    margin-top: 40px;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em;
    color: #2d3748;
}

.markdown-content h3 {
    font-size: 1.25em;
    margin: 0.83em 0;
    margin-top: 40px;
    color: #2d3748;
}

.markdown-content h4 {
    font-size: 1em;
    margin: 1em 0;
    color: #2d3748;
}

.markdown-content p {
    margin: 1em 0;
}

.markdown-content ul,
.markdown-content ol {
    margin: 1em 0;
    padding-left: 2em;
}

.markdown-content li {
    margin: 0.5em 0;
}

.markdown-content blockquote {
    border-left: 4px solid #ddd;
    padding-left: 1em;
    margin: 1em 0;
    color: #666;
}

.markdown-content hr {
    margin: 2em 0;
    border: none;
    border-top: 1px solid #eee;
}

.markdown-content pre {
    background: #f5f5f5;
    padding: 1em;
    border-radius: 4px;
    overflow-x: auto;
}

.markdown-content code {
    font-family: 'Consolas', 'Monaco', monospace;
    font-size: 0.9em;
}

.markdown-content img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 1em 0;
}

.markdown-content a {
    color: #667eea;
    text-decoration: none;
}

.markdown-content a:hover {
    text-decoration: underline;
}

.markdown-content strong {
    font-weight: 700;
}

.markdown-content em {
    font-style: italic;
}

.markdown-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 1.5em 0;
    font-size: 1em;
}

.markdown-content th,
.markdown-content td {
    padding: 12px 15px;
    text-align: left;
    border: 1px solid #e8e8e8;
}

.markdown-content th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #2d3748;
}

.markdown-content tr:nth-child(even) {
    background-color: #fafbfc;
}

.markdown-content tr:hover {
    background-color: #f5f5f5;
}

.markdown-content p {
    margin: 0 !important;
}
</style>
